import { useEffect, useState } from 'react';

/** One breakpoint, matching app.css: below it is a phone, above it is a laptop. */
export const DESKTOP = '(min-width: 900px)';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const fn = () => setMatches(mq.matches);
    fn();
    mq.addEventListener('change', fn);
    return () => mq.removeEventListener('change', fn);
  }, [query]);
  return matches;
}

export const useIsDesktop = () => useMediaQuery(DESKTOP);
